import { apiupload, apiget, apipost } from "../../api";

export const types = {
  GET_PICTURE: "GET_PICTURE",
  SEND_PICTURE: "SEND_PICTURE",
  SEND_BINARY: "SEND_BINARY",
  SET_AUTHORS: "SET_AUTHORS",
  REMOVE_AUTHOR: "REMOVE_AUTHOR",
  GET_AUTHORS: "GET_AUTHORS",
  GET_FOR_AUTHOR: "GET_FOR_AUTHOR",
  BULK_SET_AUTHORS: "BULK_SET_AUTHORS",
  GET_PICTURE_WITH_AUTHORS: "GET_PICTURE_WITH_AUTHORS"
};

export const actions = {
  [types.SEND_PICTURE]: token => async (_, file) =>
    await apiupload("/upload/picture", file, token),
  [types.GET_PICTURE]: token => async (_, id) =>
    await apiget(`/picture/${id}`, {}, token),
  [types.GET_PICTURE_WITH_AUTHORS]: token => async (_, id) =>
    await apiget(`/picture/${id}?with_authors=1`, {}, token),
  [types.SET_AUTHORS]: token => async (_, { picture, authors }) =>
    await apipost(`/authors/${picture.id}`, { authors }, token),
  [types.REMOVE_AUTHOR]: token => async (_, { picture, author }) =>
    await apipost(`/authors/${picture.id}/remove`, { author }, token),
  [types.GET_AUTHORS]: token => async (_, { picture }) =>
    await apiget(`/author/${picture.id}/authors`, {}, token),
  [types.GET_FOR_AUTHOR]: token => async (_, { contact }) =>
    await apiget(`/author/${contact.id}/pictures`, {}, token),
  [types.BULK_SET_AUTHORS]: token => async (_, { pictures, authors }) =>
    await apipost(
      `/authors_bulk/${pictures.map(p => p.id)}/authors`,
      { authors: authors.map(a => a.id) },
      token
    ),
  [types.SEND_BINARY]: token => async (_, file) => {
    return await apiupload("/upload/binary", file, token);
  }
};
